import React, { useEffect } from 'react';
import { FileText as FilePdf, X } from 'lucide-react';

const PdfPreviewModal = ({ 
  isOpen, 
  selectedFile, 
  files = [], 
  onSelectFile, 
  onClose 
}) => {
  // Handle Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen || !selectedFile) return null;

  return (
    <div className="fixed inset-0 z-[100] flex bg-slate-900/60 backdrop-blur-sm">
      {/* Left Panel - Document List (Hidden on mobile/small tablet) */}
      {files && files.length > 0 && (
        <div className="hidden md:flex w-[35%] min-w-[250px] max-w-[250px] bg-white h-full shadow-2xl flex-col translate-x-0">
          <div className="p-5 border-b border-slate-100 flex items-center justify-between bg-slate-50/50">
            <h2 className="text-lg font-bold text-slate-800 flex items-center gap-2">
              <FilePdf size={20} className="text-red-500" />
              Daftar Dokumen
            </h2>
          </div>
          <div className="flex-1 overflow-y-auto p-4 flex flex-col gap-3">
            {files.map(file => (
              <div
                key={file.id}
                onClick={() => onSelectFile && onSelectFile(file)}
                className={`flex items-center gap-3 p-3 rounded-xl cursor-pointer transition-all border ${selectedFile.id === file.id
                  ? 'bg-blue-50 border-blue-200 shadow-sm'
                  : 'bg-white border-slate-200 hover:border-blue-300 hover:shadow-sm'
                  }`}
              >
                <div className={`p-2 rounded-lg ${selectedFile.id === file.id ? 'bg-blue-100 text-blue-600' : 'bg-slate-100 text-slate-500'}`}>
                  <FilePdf size={20} />
                </div>
                <div className="flex flex-col overflow-hidden w-full">
                  <span className={`text-sm font-semibold truncate ${selectedFile.id === file.id ? 'text-blue-700' : 'text-slate-700'}`} title={file.name}>
                    {file.name}
                  </span>
                  <span className="text-xs text-slate-500">PDF Document</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Right Panel - PDF Viewer */}
      <div className="flex-1 h-full p-2 md:p-6 flex flex-col relative w-full">
        <div className="w-full h-full bg-slate-100 rounded-xl md:rounded-2xl shadow-2xl overflow-hidden flex flex-col border border-white/20 relative">
          <div className="h-14 border-b border-slate-200 flex items-center px-5 bg-white justify-between shrink-0">
            <div className="flex items-center gap-3 overflow-hidden">
              <div className="p-1.5 bg-red-100 rounded-lg shrink-0">
                <FilePdf size={18} className="text-red-600" />
              </div>
              <span className="text-sm font-bold text-slate-700 truncate" title={selectedFile.name}>{selectedFile.name}</span>
            </div>
            <div className="flex items-center gap-3 shrink-0 ml-4">
              <a
                href={selectedFile.url}
                target="_blank"
                rel="noreferrer"
                className="text-sm font-semibold text-blue-600 hover:text-blue-700 hover:underline px-2 md:px-3 py-1.5 rounded-lg hover:bg-blue-50 transition-colors whitespace-nowrap"
              >
                <span className="hidden sm:inline">Buka di Tab Baru</span>
                <span className="sm:hidden">Buka</span>
              </a>
              <div className="w-[1px] h-5 bg-slate-300"></div>
              <button
                onClick={onClose}
                className="p-1.5 text-slate-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors flex items-center justify-center"
                title="Tutup Preview (Esc)"
              >
                <X size={20} />
              </button>
            </div>
          </div>
          <iframe
            src={selectedFile.url}
            className="w-full h-full flex-1 bg-slate-100"
            title={selectedFile.name}
          />
        </div>
      </div>
    </div>
  );
};

export default PdfPreviewModal;
